import {
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
  useSuspenseQuery,
} from '@tanstack/react-query'
import type {
  UserAddUserBankAccountInput,
  UserGetUserBankAccountsInput,
  UserSetDefaultUserBankAccountInput,
} from '../api'
import type { IMutationArgs } from '../types'
import { userBankGetOptions } from './user-bank.options'
import userBankService from './user-bank.service'
import { EUserBankQueryKey } from './user-bank.types'

export const useCreateBank = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: UserAddUserBankAccountInput) =>
      userBankService.create(data),
    mutationKey: [EUserBankQueryKey.CREATE],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({ queryKey: [EUserBankQueryKey.GET] })
      return data
    },
  })
}

export const usePrefetchGetBanks = (args: UserGetUserBankAccountsInput) => {
  return useSuspenseQuery(queryOptions(userBankGetOptions(args)))
}

export const useGetBanks = (args: UserGetUserBankAccountsInput) => {
  return useQuery(userBankGetOptions(args))
}

export const useDeleteBank = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: number[]) => userBankService.remove(data),
    mutationKey: [EUserBankQueryKey.DELETE],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({ queryKey: [EUserBankQueryKey.GET] })
      return data
    },
  })
}

export const useSetDefaultBank = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: UserSetDefaultUserBankAccountInput) =>
      userBankService.setDefault(data),
    mutationKey: [EUserBankQueryKey.SET_DEFAULT],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({ queryKey: [EUserBankQueryKey.GET] })
      return data
    },
  })
}
